import { Fragment } from "react";
import { netural400, neturalBlack } from "../../constants/color";

const OrderDetail = ({ orderInfo }) => {
  const formatDate = (inputDate) => {
    const options = {
    //   weekday: "short",
      month: "long",
      day: "2-digit",
      year: "numeric",
    };

    const date = new Date(inputDate);
    return date.toLocaleDateString("en-US", options);
  };
  return (
    <div
      style={{
        marginTop: "5%",
        paddingBottom: "4%",
        borderBottom: "1px solid #dadada",
      }}
    >
      <Fragment>
        <label
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: neturalBlack,
          }}
        >
          Order details
        </label>
      </Fragment>
      <div
        style={{
          marginTop: "3%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <label
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: neturalBlack,
          }}
        >
          OrderId
        </label>
        <label style={{ fontSize: "16px", color: netural400 }}>
          #{orderInfo.orderId}
        </label>
      </div>
      <div
        style={{
          marginTop: "1%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <label
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: neturalBlack,
          }}
        >
          Order date
        </label>
        <label style={{ fontSize: "16px", color: netural400 }}>
          {formatDate(orderInfo.orderDate)}
        </label>
      </div>
    </div>
  );
};

export default OrderDetail;
